<div class="wrapper-page-single-blog">
  <div class="zc-container">
    <div class="grid">
      <div class="grid__s-12">
        <!--    TODO JS - Na celo ovo ide click za back na stranicu    -->
        <div class="wrapper-back-to-page">
          <img src="../../../../../assets/icons/landing/icon-arrow-back-page.png" alt="">
          <span>Nazad na blog</span>
        </div>
      </div>
    </div>
  </div>
  <!--  Content blog   -->
  <div class="zc-container content-single-blog">
    <div class="grid">
      <div class="grid__s-12">
        <div class="wrapper-cover-image-blog">
          <img src="../../../../../assets/images/landing/single-blog-cover-image.jpg" alt="">
        </div>
      </div>
      <div class="grid__s-12">
        <div class="wrapper-info-blog">
          <div class="wrapper-category-label blue">
            <span>Torte</span>
          </div>
          <span class="label-blog-info">1 min ago</span>
          <span class="label-blog-info">Zoran Kuštrimović</span>
        </div>
      </div>
    </div>
  </div>
</div>
